import { ISelectOption } from '@apps-common/types/form'

export const UnitActivationAction = {
  forceCancel: 'force-cancel',
  activateNow: 'now',
  retryNow: 'retry-now',
  powerUp: 'power-up',
  retryPowerUp: 'retry-power-up',
  edit: 'edit',
  delete: 'delete',
  archive: 'archive',
  cancel: 'cancel',
  terminate: 'terminate'
}

export const UnitActivationStatus = {
  awaitingstart: 'awaitingstart',
  awaitingpowerup: 'awaitingpowerup',
  pending: 'pending',
  success: 'success',
  cancelled: 'cancelled',
  archived: 'archived',
  failed: 'failed'
}

export type UnitActivationStatus =
  | 'awaitingstart'
  | 'awaitingpowerup'
  | 'pending'
  | 'success'
  | 'cancelled'
  | 'archived'
  | 'failed'
  | 'unknown'

export const UnitActivationStatusDescription: Record<UnitActivationStatus, string> = {
  awaitingstart: 'Awaiting Start',
  awaitingpowerup: 'Awaiting Power Up',
  pending: 'Pending',
  success: 'Success',
  cancelled: 'Cancelled',
  archived: 'Archived',
  failed: 'Failed',
  unknown: 'Unknown'
}

export const UnitActivationStatusTone: Record<UnitActivationStatus, string> = {
  awaitingstart: 'status-info',
  awaitingpowerup: 'status-pending',
  pending: 'status-pending',
  success: 'status-success',
  cancelled: 'status-neutral',
  archived: 'status-neutral',
  failed: 'status-error',
  unknown: 'status-unknown'
}

export const UNIT_ACTIVATION_STATUS_VALUES: ISelectOption[] = [
  { label: 'Awaiting Start', value: UnitActivationStatus.awaitingstart },
  { label: 'Awaiting Power Up', value: UnitActivationStatus.awaitingpowerup },
  { label: 'Pending', value: UnitActivationStatus.pending },
  { label: 'Success', value: UnitActivationStatus.success },
  { label: 'Cancelled', value: UnitActivationStatus.cancelled },
  { label: 'Failed', value: UnitActivationStatus.failed },
  { label: 'Archived', value: UnitActivationStatus.archived }
]

export const UNIT_ACTIVATION_UPDATE_LISTENER_STATUSES = [
  UnitActivationStatus.awaitingstart,
  UnitActivationStatus.awaitingpowerup,
  UnitActivationStatus.pending,
  UnitActivationStatus.failed
]
